/**
 * 图表卡片组件
 */

import React from 'react';
import { Card, Space, Typography } from 'antd';

const { Title, Text } = Typography;

export interface ChartCardProps {
  title?: string;
  subTitle?: string;
  extra?: React.ReactNode;
  children: React.ReactNode;
  
  // 样式相关
  loading?: boolean;
  bordered?: boolean;
  size?: 'small' | 'default' | 'large';
  
  // Card属性
  cardProps?: any;
}

/**
 * 图表卡片组件
 */
const ChartCard: React.FC<ChartCardProps> = ({
  title,
  subTitle,
  extra,
  children,
  loading = false,
  bordered = true,
  size = 'default',
  cardProps,
}) => {
  // 渲染标题区域
  const renderTitle = () => {
    if (!title && !subTitle) return null;

    return (
      <Space direction="vertical" size="small" style={{ marginBottom: 16 }}>
        {title && (
          <Title level={4} style={{ margin: 0 }}>
            {title}
          </Title>
        )}
        {subTitle && (
          <Text type="secondary">
            {subTitle}
          </Text>
        )}
      </Space>
    );
  };

  return (
    <Card
      loading={loading}
      bordered={bordered}
      size={size}
      extra={extra}
      {...cardProps}
    >
      {renderTitle()}
      <div style={{ height: 300 }}>
        {children}
      </div>
    </Card>
  );
};

export default ChartCard;